module.exports = new Promise((resolve) => {
    const script = document.createElement('script');
    let settled = false;
    const fail = (message) => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      console.warn(message);
      resolve({
        get: () => Promise.reject(new Error(message)),
        init: () => undefined
      });
    };
    script.src = 'https://app.bellwetherit.com/assets/procurement/remoteEntry.js';
    script.onload = () => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      resolve({
        get: (request) => window['procurementRemote']
          ? window['procurementRemote'].get(request)
          : Promise.reject(new Error('Module procurementRemote not available')),
        init: (shareScope) => {
          try {
            return window['procurementRemote'] ? window['procurementRemote'].init(shareScope) : undefined;
          } catch (error) {
            console.warn('procurementRemote init failed:', error);
            return undefined;
          }
        }
      });
    };
    script.onerror = () => fail('Failed to load remote: procurementRemote');
    const deadline = setTimeout(() => fail('Timed out loading remote: procurementRemote'), 10000);
    document.head.appendChild(script);
  });